import { render, staticRenderFns } from "./i4pro-floating-action-buttons.vue?vue&type=template&id=12986922&scoped=true"
import script from "./i4pro-floating-action-buttons.vue?vue&type=script&lang=js"
export * from "./i4pro-floating-action-buttons.vue?vue&type=script&lang=js"
import style0 from "./i4pro-floating-action-buttons.vue?vue&type=style&index=0&id=12986922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12986922",
  null
  
)

export default component.exports